import React from 'react';
import { faRoad } from '@fortawesome/pro-solid-svg-icons/faRoad';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function RoadSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faRoad} {...props} />;
}
